import React, { createContext, useState } from 'react';

import TimeData from './TimeData';

export const SessionStateContext = createContext();

const SessionContextProvider = ({ children }) => {
  const stateHook = useState(TimeData.INITIAL_STATE);

  return (
    <SessionStateContext.Provider value={stateHook}>
      {children}
    </SessionStateContext.Provider>
  );
};

export default SessionContextProvider;